import { render, staticRenderFns } from "./regulations.vue?vue&type=template&id=30de4f12&"
import script from "./regulations.vue?vue&type=script&lang=js&"
export * from "./regulations.vue?vue&type=script&lang=js&"
import style0 from "./regulations.vue?vue&type=style&index=0&id=30de4f12&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports